// src/components/Layout.js

import React from 'react';
import { useLocation } from 'react-router-dom';
import TopNav from './TopNav';       // Barra de navegación superior
import BottomNav from './BottomNav'; // Barra de navegación inferior
import backgroundImage from '../assets/weight-plates.jpg';

const Layout = ({ children }) => {
  const location = useLocation();

  // Lista de rutas donde no se mostrará ninguna barra de navegación (páginas públicas).
  const noNavRoutes = ['/login', '/register'];

  // Variable booleana que nos dice si estamos en una página pública.
  const isAuthPage = noNavRoutes.includes(location.pathname);

  return (
    <div
      className="min-h-screen bg-center bg-cover relative overflow-x-hidden"
      style={{
        backgroundImage: `linear-gradient(160deg, rgba(8,10,16,0.9), rgba(12,16,25,0.82)), url(${backgroundImage})`
      }}
    >
      <div className="pointer-events-none absolute -top-36 -left-20 w-96 h-96 rounded-full bg-red-900/20 blur-3xl" />
      <div className="pointer-events-none absolute top-1/3 -right-24 w-96 h-96 rounded-full bg-blue-900/20 blur-3xl" />
      <div className="pointer-events-none absolute inset-0 opacity-[0.08]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)', backgroundSize: '24px 24px' }} />

      {/* CONTENEDOR FLEXBOX INTERNO: Distribuye el contenido verticalmente. */}
      <div className="relative z-10 flex flex-col min-h-screen">
        
        {/* ===== INICIO DEL CAMBIO ===== */}

        {/* 1. Renderizado condicional de la TopNav. */}
        {/*    Solo se muestra si NO estamos en una página de login o registro. */}
        {!isAuthPage && <TopNav />}
        
        {/* ===== FIN DEL CAMBIO ===== */}

        {/* 'main' ocupa el espacio disponible. */}
        {/* Su estilo cambia para centrar el contenido en las páginas de auth. */}
        <main
          className={`flex-grow flex flex-col ${isAuthPage ? 'justify-center items-center p-4' : 'px-3 md:px-4 pt-4 pb-6'}`}
        >
          {children} {/* Aquí se renderiza el contenido de la página actual */}
        </main>
        
        {/* Renderizado condicional de la BottomNav (lógica existente). */}
        {!isAuthPage && <BottomNav />}

      </div>
    </div>
  );
};

export default Layout;